// d:\qyx_workspace\bitwebsite-client-1\src\api\index.js
import { request } from '../util/request'

export * from './New.ts'
export * from './statistic'
export * from './node'

export function stylePhotosList(category = 0) {
  const base = process.env.VUE_APP_NEWS_API_BASE || 'http://192.168.56.109:9016'
  return request({
    url: `${base}/server/app/stylePhotos/list`,
    method: 'post',
    data: { category }
  })
}

export function allTicker() {
  return request({
    url: 'https://api.bidacoin.co/api/v1/sapi/allTicker',
    method: 'get'
  })
}

export function bitUsdtPrice() {
  const base =
    process.env.VUE_APP_WALLET_API_BASE ||
    (process.env.NODE_ENV === 'production'
      ? 'http://bitwalletapi.bitnetworkbc.com/wallet'
      : 'http://47.236.254.203:9008/wallet')
  return request({
    url: `${base}/app/price/bit-usdt`,
    method: 'get'
  })
}

export function parseBitUsdtPrice(response) {
  const raw = typeof response === 'string'
    ? (() => { try { return JSON.parse(response) } catch { return {} } })()
    : response
  const data = raw?.data ?? raw ?? {}
  return data?.records ?? data?.price ?? data?.last ?? data?.close ?? ''
}

export function voteRealPage() {
  const url = process.env.VUE_APP_VOTE_API_URL || `${process.env.VUE_APP_BITS_API_BASE}/vote/real/page`
  return request({ url, method: 'get' })
}

export function bitsStatisticHome() {
  const base =
    process.env.VUE_APP_BITS_API_BASE ||
    (process.env.NODE_ENV === 'production'
      ? 'http://chaindataapi.bitnetworkbc.com/bitscan'
      : 'http://47.236.254.203:9000/bitscan')
  const url = `${base}/statistic/home`
  return request({ url, method: 'get' })
}

export function bitsStatisticBlock() {
  const base =
    process.env.VUE_APP_BITS_API_BASE ||
    (process.env.NODE_ENV === 'production'
      ? 'http://chaindataapi.bitnetworkbc.com/bitscan'
      : 'http://47.236.254.203:9000/bitscan')
  const url = `${base}/statistic/block`
  return request({ url, method: 'get' })
}
